import { ellipsisStyle } from "@msys/ui";
import { Description as DescriptionIcon } from "@mui/icons-material";
import {
  Link,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemProps,
  ListItemText,
} from "@mui/material";
import React from "react";

interface Props {
  file: {
    url: string;
    title: string;
  };
  secondaryAction?: React.ReactNode;
}

export const FileListItemButton = ({
  file,
  secondaryAction,
  ...props
}: Props & ListItemProps) => {
  return (
    <ListItem
      dense
      component="div"
      disablePadding
      secondaryAction={secondaryAction}
      {...props}
    >
      <ListItemButton
        dense
        component={Link}
        href={file.url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(event: React.MouseEvent<HTMLElement>) => {
          event.stopPropagation();
        }}
        style={ellipsisStyle}
      >
        <ListItemIcon
          sx={theme => ({
            minWidth: theme.layout.listItemMinWidth.xs,
            display: "flex",
            alignItems: "center",
          })}
        >
          <DescriptionIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText
          style={ellipsisStyle}
          primary={file.title}
          slotProps={{
            primary: { style: ellipsisStyle },
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};
